

































import { Component, Mixins } from "vue-property-decorator";
import {
  Dataset,
  PromptTemplate,
  DefaultPromptTemplate,
} from "#/model/admin/index";
import { Choice } from "@/types";
import PromptTemplateEditor from "@/components/aivnplan/PromptTemplateEditor.vue";
import PromptTemplateExperiment from "@/components/aivnplan/PromptTemplateExperiment.vue";
import AxiosMixin from "@/mixins/axiosMixin";
import RulesMixin from "#/mixins/rulesMixin";
import UtilMixin from "@/mixins/utilMixin";

@Component({
  components: {
    PromptTemplateEditor,
    PromptTemplateExperiment,
  },
})
/** プロンプトテンプレート編集 */
export default class PromptTemplateForm extends Mixins(
  AxiosMixin,
  UtilMixin,
  RulesMixin
) {
  /** 変数 */

  /** タブ */
  private tab = 0;

  /** 編集モード */
  private mode = "";

  /** プロンプトテンプレート */
  private promptTemplate: PromptTemplate = DefaultPromptTemplate();

  /** データセット選択肢 */
  private datasetChoice: Choice[] = [];

  /** 登録済みデータセット */
  private datasets: Dataset[] = [];

  /** getter */

  /** コピーモード */
  private get IsCopyMode(): boolean {
    return this.mode == "copy";
  }

  /** 関数 */

  created() {
    this.mode = this.$route.query.mode as string;
    this.fetch();
  }

  /** 取得 */
  private fetch() {
    const promptTemplateId = Number(this.$route.params.id);
    this.postJsonCheck(
      window.base_url + "/api/admin/aivnplan/prompt/get",
      { id: promptTemplateId },
      async (res) => {
        this.promptTemplate = res.data.prompt_template;
        this.datasetChoice = res.data.dataset_choice;
        this.datasets = res.data.datasets;

        if (this.IsCopyMode) {
          this.promptTemplate.name += "のコピー";
          this.promptTemplate.comment = "";
        }
      }
    );
  }

  /** プロンプトテンプレート保存 */
  private save() {
    // 既存テンプレートのコピー時はid=0にして新規作成扱い
    if (this.IsCopyMode) {
      this.promptTemplate.id = 0;
    }

    this.postJsonCheck(
      window.base_url + "/api/admin/aivnplan/prompt/save",
      { prompt_template: this.promptTemplate },
      async () => {
        this.moveToListPage();
      }
    );
  }

  /** プロンプトテンプレート削除 */
  private deletePromptTemplate() {
    this.postJsonCheck(
      window.base_url + "/api/admin/aivnplan/prompt/delete",
      { prompt_template: this.promptTemplate },
      async () => {
        this.moveToListPage();
      }
    );
  }

  /** 編集キャンセル */
  private cancel() {
    this.moveToListPage();
  }

  /** 一覧画面に戻る */
  private moveToListPage() {
    this.$router.push({ path: "/ai-vnplan/prompt/list" });
  }
}
